module.exports = __webpack_public_path__ + "static/media/warranty.e76a658c.pdf";